import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MozAdvertisingFileList.html?raw';
import '../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import '../../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';
import '../../../../moreCore/UI/CheckBox/CheckBox';
import '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../../moreCore/UI/SearchSelect/SearchSelect";
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../../_loadingHelpers/VAMv2Types";
import EntityStore from '../../../../moreCore/Tools/EntityStore';
import FileUpload from '../../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
//import FileUploadDisplay_ListRow = require("../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow");
import { FileUploadTypes } from "../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";
import FileUploadDisplay_ListRow from '../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import PageStack from '../../../../moreCore/UI/Tabbing/PageStack';
import "../../../../moreCore/UI/Tabbing/PageStack";
import Tooltip from '../../../../moreCore/UI/Floating/Tooltip';

import filePreview from '../../../../WidgetCollection/filePreview/filePreview';

class MozAdvertisingFileList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    private fileCategories: Array<{ ID: string, description: string }> = [];
    private bookingFilesTableContainer: HTMLElement;
    //private newUploadFiles: Array<VAM2types.FileUploadWithCategories> = [];

    private pagestack: MdsLax<InstanceType<typeof PageStack>>;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.VtFiles | VAM2types.FileUploadWithCategories>>>;
    private evBookingId: string;
    private entitylist: Array<VAM2types.VtFiles>;


    private uploadUnits: Array<VAM2types.FileUploadWithCategories>
    private removedFiles: Array<string>;

    private filePreviewWidget:MdsLax<InstanceType<typeof filePreview>>;

    existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description", "ref_entity_1.$ClassPrintname"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Source"],
        "colspans": [1, 1, 1, 1],
        "headings": ["General_Label_Filename","General_Label_Keyword", "General_Label_Category", "General_Label_Source"],
        widths: [null, null, null, "15ch"],
        alignmentsHeading: [null, null, null, null],
        alignmentsRow: [null, null, null, null]
    };

    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.VtFiles>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        console.log(colName);

        switch (colName) {
            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity && fileEntity.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1?.$Displayname,
                        targetnode: node,
                        enableHover: true,
                        enableClick: true,
                        heading: value
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                else {
                    cell.value = null;
                    return false;
                }
                break;
        }

        return false;
    }

    private _emitHandle: any = null;
    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();


        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.uploadUnits), 100);
    }


    getData(): EntityStoreData<VAM2types.VtFiles> {
        let data: EntityStoreData<VAM2types.VtFiles> = {
            changed: [],
            deleted: [],
            new: []
        };

        let storeData = this.store.getDiffData();

        data.new = this.uploadUnits as any;

        data.deleted = storeData.deleted;
        data.changed = storeData.changed as any;

        return data;
    }

    private setupTable(): void {
        //Files_Edit
        this.tableContainer.innerHTML = null;


        this.table = new StaticTable();

        this.table.addDefaultRowActionButton("delete", lang.hitch(this, this._onRowDeleting));//, 
        let dlIcon = "fas fa-download";
        if (this.hasFeature("filePreview", "useInEvBookingFileList")){
            dlIcon = "fas fa-search";
        }
        this.table.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), dlIcon);
        this.table.setFormatter(this.table_formatterFunction);
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        this.table.addLineConfig(this.existingFilesTableLayout);

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);
        this.table.setCyAttribute("MozAdvertisingFileList");


        let list = this.store.getCurrentCompleteList("existing");
        this.table.enableActionButton("delete", null, false);// erst deaktivieren - wird asynchron mit privilege gemacht // lang.hitch(this, this._onCheckFileDeletable));
        for (let entry of list) {
            this.webPrivilegeManager.loadPrivilegesForEntity(entry, lang.hitch(this, this._onEntityPrivilegeReady, entry));
        }
    }

    private _onCheckFileDeletable(entity: VAM2types.VtFiles): boolean {
        return true;
    }

    /*private setupProjectFilesTable(): void {
        this.projectFilesTableContainer.innerHTML = null;

        this.projectFilesTable = new StaticTable();

        let dlIcon = "fas fa-download";
        if (this.hasFeature("filePreview", "useInEvBookingFileList")) {
            dlIcon = "fas fa-search";
        }
        this.projectFilesTable.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), dlIcon);
        this.projectFilesTable.setFormatter(this.table_formatterFunction);

        this.projectFilesTable.addLineConfig(this.existingFilesTableLayout);

        this.UiModder.domConstruct.place(this.projectFilesTable.domNode, this.projectFilesTableContainer);

        this.projectFilesTable.setupFromStore(this.projectFilesStore);
    }*/

    private _onEntityPrivilegeReady(file: VAM2types.VtFiles) {
        //this.hasUserRole("Files_Delete", lang.hitch(this, this._onDeletePrivilege, file), file);
        
        this.table.enableActionButton("delete", file, lang.hitch(this, this.hasUserRole, "Files_Delete", null, file) as any);
    }
    //private _onDeletePrivilege(file: VAM2types.VtFiles, hasPrivilege: boolean) {
    //    this.table.enableActionButton("delete", file, hasPrivilege);

    //}


    private extendFileupload(uploadData: FileUploadTypes.UploadUnit): VAM2types.FileUploadWithCategories {

        let pseudoFiles = [];
        let count = 0;
        let exFile: VAM2types.FileUploadWithCategories = {
            ...uploadData,
            fileCategories: [],            
        }


        exFile["photo_credit"] = this.store.getComplexProperty(uploadData.guid, "photo_credit");
        exFile["allow_usage"] = this.store.getComplexProperty(uploadData.guid, "allow_usage");
        //debugger;

        
        return exFile;
    }

    private _onRemovedUpload(removedFile: FileUploadTypes.UploadDescriptor) {

        // TODO: Pseudoentry im Store finden (! mit guid und count nicht möglich, weils ja gerade entfernt worden ist!!) und entfernen,
        // damit sich die Liste neu zeichnet.
        var currentCompleteList = this.store.getCurrentCompleteList();
        var listItem:VAM2types.VtFiles;
        for (listItem as any of currentCompleteList) {
            if (listItem.ID.match(removedFile.uploadGUID)) {
                this.store.deleteEntry(listItem);
            }
        }
        //// Liste der Uploads aktualisieren:
        //for (let i = 0; i < this.uploadedFiles.length; i++) {
        //    let upload = this.uploadedFiles[i];
        //    if (removedFile.uploadGUID == upload.guid) {
        //        this.uploadedFiles.splice(i, 1);

        //        this._onChange_StoreData();

        //        this._onChangeUploadFile();
        //        return;
        //    }
        //}
    }

    private _onRowDeleting(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.VtFiles>): void {
    //    let entity = rowGrp.entity;
    //    if (entity.ID.match("__")) {
    //        let guid = entity.ID.split("__")[0];
    //        let filename = entity.filename;
    //        debugger;
    //        this.fileUpload.removeUploadedFile(guid, filename);
        //    }
        
        // des gematche von wegen temporäre Uploads gibts nicht mehr. der Filupload löscht seine Uploads selber
        // ansonsten führt das Delete zur Löschung im Store und dann übernimmt der VAB-Editor.
    }


    private _onChangeUploadFile() {
        let uploadUnits = this.fileUpload.getValue();

        if (uploadUnits && this.fileUpload.validateInput()) {

            uploadUnits.forEach(uploadUnit => {

                let guid = uploadUnit.guid;
                let fileNames = uploadUnit.filenames
                let existingUploadUnit: VAM2types.FileUploadWithCategories = null;
                for (let upload of this.uploadUnits) {
                    if (upload.guid == guid) {
                        existingUploadUnit = upload;
                        break;
                    }
                }

                // wenns noch nicht im eigenne Array registriert ist: erweitern um Kategorien
                if (!existingUploadUnit) {
                    let exUnit = this.extendFileupload(uploadUnit);

                    this.uploadUnits.push(exUnit);

                    let count = 0;
                    for (let file of exUnit.files) {
                        count++;
                        let pseudofile: VAM2types.FileWithCategory = {
                            filename: file.FileName,
                            ref_file_category: this.fileCategories[0],
                            ID: file.FileGUID,

                        }

                        pseudofile["photo_credit"] = null;
                        pseudofile["allow_usage"] = false;
                        this.store.addEntry(pseudofile);
                    }
                } else {
                    // Achtung, es könnte was entfernt worden sein
                    // bestehenden Upload-Datensatz nochmal updaten:
                    existingUploadUnit.filenames = uploadUnit.filenames;
                    existingUploadUnit.files = uploadUnit.files;
                }
            });


        } else {

        }
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "EvBookingEditor/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    protected _onUploadRowsCreated(rows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>>): void {
        let category = this.fileCategories[0];
        if (!category) return;

        for (let row of rows) {
            let fileRow = row;

            let copyrightCredits = new Edit();
            copyrightCredits.setLabel("Fotocredit");
            copyrightCredits.on("change", lang.hitch(this, this._onChanged_FotoCredit, fileRow));

            fileRow.addContent(copyrightCredits.domNode);

            let cb = new CheckBox();
            cb.setLabel("Ja, dieses Bild darf für Web & Druck verwendet werden");
            cb.on("change", lang.hitch(this, this._onChanged_FotoCheckbox, fileRow));

            fileRow.addContent(cb.domNode);

        }
    }

    _onChanged_FotoCredit(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {
        let file = fileRow.getData();
        let rowUploadGUID = file.uploadGUID
        let rowFileName = file.FileName;

        let targetUpload: VAM2types.FileUploadWithCategories = null;
        for (let upload of this.uploadUnits) {
            if (rowUploadGUID == upload.guid) {
                targetUpload = upload;
                break;
            }
        }

        if (targetUpload) {
            targetUpload["photo_credit"] = value;
            this.store.setEntityAttributeValue(file.FileGUID, "photo_credit", value);
        }
    }

    _onChanged_FotoCheckbox(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {
        let file = fileRow.getData();
        let rowUploadGUID = file.uploadGUID
        let rowFileName = file.FileName;

        let targetUpload: VAM2types.FileUploadWithCategories = null;
        for (let upload of this.uploadUnits) {
            if (rowUploadGUID == upload.guid) {
                targetUpload = upload;
                break;
            }
        }

        if (targetUpload) {
            targetUpload["allow_usage"] = value;
            this.store.setEntityAttributeValue(file.FileGUID, "allow_usage", value);
        }
    }

    /*private _onChange_FileCategory(fileRow: FileUploadDisplay_ListRow, categorySelect: SearchSelect, value: string): void {

        let file = fileRow.getData();
        let rowUploadGUID = file.uploadGUID
        let rowFileName = file.FileName;

        let targetUpload: VAM2types.FileUploadWithCategories = null;
        for (let upload of this.uploadUnits) {
            if (rowUploadGUID == upload.guid) {
                targetUpload = upload;
                break;
            }
        }

        let selectedCategory = categorySelect.getValue(true) as { ID: string, description: string };
        
        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (targetUpload) {
            for (let categoryAssignment of targetUpload.fileCategories) {
                let count = 0;
                if (categoryAssignment.fileName == rowFileName) {
                    count++;
                    categoryAssignment.category = selectedCategory.ID;

                    this.store.setEntityAttributeValue(file.FileGUID, "ref_file_category", selectedCategory);

                }
            }
        }
    }*/

    private _downloadFile(file): void {
        if (this.hasFeature("filePreview", "useInEvBookingFileList") == false){
            if (file.entity.Classname) {
                window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${file.entity["ID"]}`);
            } else {
                this.showToast(this.translate("General_Error_FileNotUploaded"), "fas fa-exclamation-triangle");
            }
        }else{
            this.StandbyStart();
            this.filePreviewWidget = new filePreview();
            this.filePreviewWidget.show(
                {key:file["entity"]["ID"]},
                true,
                true,
                lang.hitch(this, ()=>{
                    this.StandbyStop();
                }),
                lang.hitch(this, ()=>{
                    this.showToast(this.translate("General_Error"), "fas fa-exclamation-triangle");
                    this.StandbyStop();
                })
            );
        }
    }

    setup(data: Array<VAM2types.VtFiles>, evBookingId: string, projectFiles?: Array<VAM2types.VtFiles>) {
        this.store.setup(data, "ID");
        //this.projectFilesStore.setup(projectFiles, "ID");
        this.evBookingId = evBookingId;
        this.entitylist = data;


        this.setupTable();
        //this.setupProjectFilesTable();

        this.fileUpload.resetFileUpload();
        this.uploadUnits = [];

        //this.hasUserRole("---dummy---", lang.hitch(this, this._onPrivilegesLoaded));

        if (this.evBookingId) {
            let stumpEntity: Partial<VAM2types.EvBooking_Base> = {
                Classname: VAMclassNames.ht_evbooking_evcategorie1, ID: this.evBookingId
            }

            this.webPrivilegeManager.loadPrivilegesForEntity(stumpEntity, lang.hitch(this, this._onPrivilegesLoaded));

        } else {
            this._onPrivilegesLoaded();
        }
    }

    private _onPrivilegesLoaded() {

        //debugger;

        let stumpEntity: Partial<VAM2types.EvBooking_Base> = {
            Classname: VAMclassNames.ht_evbooking_evcategorie1, ID: this.evBookingId
        }
        if (this.hasUserRole("Files_Create", null, this.evBookingId ? stumpEntity : null)) {
            this.pagestack.showPage("advertising_files_upload");

            if (!this.store.getCurrentCompleteValueList().length ) {
                this.pagestack.switchToPage("advertising_files_upload")
            }
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);



        this.useStandbyManager = true;

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        //this.projectFilesStore = new EntityStore();

        this.fileUpload.on("complete_remove", lang.hitch(this, this._onRemovedUpload))
    }
    startup(): void {
        super.startup.apply(this, arguments as any);


        if (this.hasFeature("EvBooking/FileManage")) {
            //console.debug(this.id + " startup - register event listener");
            this.fileUpload.setup({ uploadCallback: lang.hitch(this, this._onUploadRowsCreated) })
            this._loadFileCategoriesList();


            this.pagestack.activatePageByName("advertising_files_default");
            //this.pagestack.disablePage("upload", this.isReadonly());
        }
    }
}

export default mdsWidget(MozAdvertisingFileList);
